import { render, staticRenderFns } from "./ProfileUniqueGemport.vue?vue&type=template&id=53e19e75&"
import script from "./ProfileUniqueGemport.vue?vue&type=script&lang=js&"
export * from "./ProfileUniqueGemport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports